import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";
import FadeIn from "react-fade-in";
import LoadAnim from "../App/LoadAnim.js";
import "./Admin.css";

let isMounted = false;

export default withAuth(
  class ActivityLogs extends Component {
    constructor(props) {
      super(props);
      this.state = {
        logs: [],
        loading: true,
        refreshing: false,
        filter: "all", // all, email_code, email_code_verification, seat_selection, seat_deselection, order_confirmation, order_check, emails
        searchTerm: "",
        currentPage: 1,
        itemsPerPage: 50
      };

      this.getActivityLogs = this.getActivityLogs.bind(this);
      this.handleFilterChange = this.handleFilterChange.bind(this);
      this.handleSearchChange = this.handleSearchChange.bind(this);
      this.formatLogEntry = this.formatLogEntry.bind(this);
      this.getLogIcon = this.getLogIcon.bind(this);
      this.getLogColor = this.getLogColor.bind(this);
      this.groupLogsByDay = this.groupLogsByDay.bind(this);
      this.handlePageChange = this.handlePageChange.bind(this);
      this.renderPagination = this.renderPagination.bind(this);
      this.getCodeColor = this.getCodeColor.bind(this);
      this.purgeActivityLogs = this.purgeActivityLogs.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      await this.getActivityLogs();
      // Auto-refresh every 30 seconds
      this.interval = setInterval(() => {
        if (isMounted) {
          this.getActivityLogs();
        }
      }, 30000);
    }

    componentWillUnmount() {
      isMounted = false;
      clearInterval(this.interval);
    }

    async getActivityLogs() {
      try {
        this.setState({ refreshing: true });
        console.log('Starting refresh - refreshing state:', true);

        const response = await authenticatedFetch("/api/admin/getActivityLogs", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });

        if (response.ok) {
          const logs = await response.json();
          // Add a small delay to ensure spinner is visible
          setTimeout(() => {
            this.setState({
              logs,
              loading: false,
              refreshing: false
            });
            console.log('Refresh complete - refreshing state:', false);
          }, 500);
        } else {
          console.error("Failed to fetch activity logs");
          this.setState({ loading: false, refreshing: false });
        }
      } catch (err) {
        console.error("Error fetching activity logs:", err);
        this.setState({ loading: false, refreshing: false });
      }
    }

    handleFilterChange(event) {
      this.setState({ filter: event.target.value });
    }

    handleSearchChange(event) {
      this.setState({ searchTerm: event.target.value, currentPage: 1 });
    }

    handlePageChange(newPage) {
      this.setState({ currentPage: newPage });
    }

    async purgeActivityLogs() {
      const confirmed = window.confirm(
        "Er du sikker på at du vil slette ALLE " + this.state.logs.length + " aktivitetslogger?\n\n" +
        "Dette kan ikke angres og vil slette all logging-historikk.\n\n" +
        "Klikk OK for å slette eller Avbryt for å avbryte."
      );

      if (!confirmed) {
        return;
      }

      try {
        const response = await authenticatedFetch("/api/admin/purgeActivityLogs", {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });

        if (response.ok) {
          alert("Aktivitetslogger er slettet.");
          // Refresh the logs to show empty state
          await this.getActivityLogs();
        } else {
          alert("Feil ved sletting av aktivitetslogger.");
        }
      } catch (err) {
        console.error("Error purging activity logs:", err);
        alert("Feil ved sletting av aktivitetslogger.");
      }
    }

    groupLogsByDay(logs) {
      const grouped = {};
      logs.forEach(log => {
        const date = new Date(log.timestamp).toDateString();
        if (!grouped[date]) {
          grouped[date] = [];
        }
        grouped[date].push(log);
      });
      return grouped;
    }

    renderPagination(totalItems, currentPage, itemsPerPage) {
      const totalPages = Math.ceil(totalItems / itemsPerPage);
      if (totalPages <= 1) return null;

      const pages = [];
      const showPages = 5;
      let startPage = Math.max(1, currentPage - Math.floor(showPages / 2));
      let endPage = Math.min(totalPages, startPage + showPages - 1);

      if (endPage - startPage < showPages - 1) {
        startPage = Math.max(1, endPage - showPages + 1);
      }

      // Previous button
      if (currentPage > 1) {
        pages.push(
          <button
            key="prev"
            onClick={() => this.handlePageChange(currentPage - 1)}
            style={{
              padding: "8px 12px",
              margin: "0 2px",
              backgroundColor: "#495057",
              color: "white",
              border: "1px solid #6c757d",
              borderRadius: "4px",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = "#6c757d"}
            onMouseLeave={(e) => e.target.style.backgroundColor = "#495057"}
          >
            ←
          </button>
        );
      }

      // Page numbers
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => this.handlePageChange(i)}
            style={{
              padding: "8px 12px",
              margin: "0 2px",
              backgroundColor: i === currentPage ? "#2B3E50" : "#343a40",
              color: "white",
              border: "1px solid #495057",
              borderRadius: "4px",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              if (i !== currentPage) e.target.style.backgroundColor = "#495057";
            }}
            onMouseLeave={(e) => {
              if (i !== currentPage) e.target.style.backgroundColor = "#343a40";
            }}
          >
            {i}
          </button>
        );
      }

      // Next button
      if (currentPage < totalPages) {
        pages.push(
          <button
            key="next"
            onClick={() => this.handlePageChange(currentPage + 1)}
            style={{
              padding: "8px 12px",
              margin: "0 2px",
              backgroundColor: "#495057",
              color: "white",
              border: "1px solid #6c757d",
              borderRadius: "4px",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = "#6c757d"}
            onMouseLeave={(e) => e.target.style.backgroundColor = "#495057"}
          >
            →
          </button>
        );
      }

      return (
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          {pages}
          <p style={{ marginTop: "10px", color: "#adb5bd" }}>
            Side {currentPage} av {totalPages} ({totalItems} totalt)
          </p>
        </div>
      );
    }

    getLogIcon(type) {
      const icons = {
        "email_code_request": { icon: "📧", tooltip: "Epost kode forespørsel" },
        "email_code_verification": { icon: "✉️", tooltip: "Epost kode verifisering" },
        "seat_selection": { icon: "🪑", tooltip: "Plassvalg" },
        "seat_deselection": { icon: "❌", tooltip: "Plassvalg" },
        "order_confirmation": { icon: "✅", tooltip: "Bestillingsbekreftelse" },
        "order_check": { icon: "🔍", tooltip: "Status sjekk" },
        "order_confirmation_email": { icon: "📮", tooltip: "Bekreftelse epost sendt" },
        "internal_notification_email": { icon: "📬", tooltip: "Internt varsel epost" },
        "server_startup": { icon: "🖥️", tooltip: "Server oppstart" },
        "dev_code_used": { icon: "🚀", tooltip: "Dev kode bruk" }
      };

      return icons[type] || { icon: "📝", tooltip: "Ukjent aktivitet" };
    }

    getCodeColor(code) {
      if (!code || code === "-") return "transparent";

      // Generate a consistent color based on the code string
      let hash = 0;
      for (let i = 0; i < code.length; i++) {
        hash = code.charCodeAt(i) + ((hash << 5) - hash);
      }

      // Convert hash to HSL color with opacity for better text contrast
      const hue = Math.abs(hash) % 360;
      const saturation = 60; // Slightly higher saturation
      const lightness = 70;  // Medium lightness
      const opacity = 0.3;   // Low opacity for subtle background

      return `hsla(${hue}, ${saturation}%, ${lightness}%, ${opacity})`;
    }

    getLogColor(type) {
      switch (type) {
        case "email_code_request":
          return "#007bff";
        case "email_code_verification":
          return "#fd7e14";
        case "seat_selection":
          return "#28a745";
        case "seat_deselection":
          return "#dc3545";
        case "order_confirmation":
          return "#ffc107";
        case "order_check":
          return "#17a2b8";
        case "order_confirmation_email":
          return "#20c997";
        case "internal_notification_email":
          return "#e83e8c";
        case "server_startup":
          return "#FFFFFF";
        case "dev_code_used":
          return "#6f42c1";
        default:
          return "#6c757d";
      }
    }

    formatLogEntry(log) {
      switch (log.type) {
        case "email_code_request":
          return {
            title: "Email verification code requested",
            description: `Code ${log.code} sent to ${log.email}`,
            details: log.details.success ? "Successfully sent" : "Failed to send"
          };
        case "email_code_verification":
          return {
            title: "Email code verification attempt",
            description: `${log.email} attempted to verify code ${log.code}`,
            details: log.details.success ?
              "Successfully verified" :
              `Failed: ${log.details.reason || "unknown reason"}`
          };
        case "seat_selection":
          return {
            title: "Seat selection",
            description: `${log.email} selected seat`,
            details: log.details.currentHeldSeats && log.details.currentHeldSeats !== "None" ?
              `Holding: ${log.details.currentHeldSeats}` :
              (log.details.seat ?
                `Held row ${log.details.seat.split('-')[0]}, seat ${log.details.seat.split('-')[1]}` :
                "Holding: None")
          };
        case "seat_deselection":
          return {
            title: "Seat deselection",
            description: `${log.email} deselected seat`,
            details: log.details.reason === "back_button_deselect" && log.details.releasedSeats ?
              `Released: ${log.details.releasedSeats}` :
              (log.details.seat ?
                `Deselected row ${log.details.seat.split('-')[0]}, seat ${log.details.seat.split('-')[1]}` :
                "All seats released")
          };
        case "order_confirmation":
          return {
            title: "Order confirmed",
            description: `${log.email} completed registration`,
            details: log.details.orderNumber ?
              `Order #${log.details.orderNumber}, ${log.details.participants || 1} participant(s)` :
              "Order details not available"
          };
        case "order_check":
          return {
            title: "Order status check",
            description: `${log.email} checked registration status`,
            details: log.details.found ? "Registration found" : "Registration not found"
          };
        case "order_confirmation_email":
          return {
            title: "Order confirmation email",
            description: `Email sent to ${log.email}`,
            details: log.details.success ?
              `Successfully sent (ID: ${log.details.messageId})` :
              `Failed: ${log.details.error}`
          };
        case "internal_notification_email":
          return {
            title: "Internal notification email",
            description: `Admin notification sent to ${log.email}`,
            details: log.details.success ?
              `Successfully sent: ${log.details.subject}` :
              `Failed: ${log.details.error}`
          };
        case "server_startup":
          return {
            title: "Server startup",
            description: `${log.details.serverType} server started`,
            details: `Port ${log.details.port} (${log.details.nodeEnv}) - Node ${log.details.version} on ${log.details.platform}`
          };
        case "dev_code_used":
          return {
            title: "Development code used",
            description: `Dev code ${log.code} used by ${log.email}`,
            details: "Development mode bypass"
          };
        default:
          return {
            title: log.type || "Unknown activity",
            description: log.email || "Unknown user",
            details: JSON.stringify(log.details)
          };
      }
    }

    render() {
      if (this.props.authenticated === null) return null;

      const filteredLogs = this.state.logs.filter(log => {
        // Filter by type
        if (this.state.filter !== "all" && log.type !== this.state.filter) {
          return false;
        }

        // Filter by search term
        if (this.state.searchTerm) {
          const searchTerm = this.state.searchTerm.toLowerCase();
          const formattedLog = this.formatLogEntry(log);
          return (
            (log.email && log.email.toLowerCase().includes(searchTerm)) ||
            (log.code && log.code.toLowerCase().includes(searchTerm)) ||
            formattedLog.title.toLowerCase().includes(searchTerm) ||
            formattedLog.description.toLowerCase().includes(searchTerm)
          );
        }

        return true;
      });

      // Pagination
      const { currentPage, itemsPerPage } = this.state;
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginatedLogs = filteredLogs.slice(startIndex, endIndex);

      // Group by day
      const groupedLogs = this.groupLogsByDay(paginatedLogs);

      return (
        <div className="SignupList">
          <h1>Aktivitetslogg</h1>

          <div style={{ marginBottom: "20px", display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" }}>
            <button
              className="btn btno btn-success edit"
              onClick={() => this.getActivityLogs()}
            >
              Oppdater
            </button>

            <button
              className="btn btno btn-danger edit"
              onClick={this.purgeActivityLogs}
              style={{ marginLeft: "10px" }}
            >
              Slett alle logger
            </button>

            <select
              value={this.state.filter}
              onChange={this.handleFilterChange}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ddd",
                fontSize: "14px"
              }}
            >
              <option value="all">Alle aktiviteter</option>
              <option value="email_code_request">Epost kode forespørsler</option>
              <option value="email_code_verification">Epost kode verifisering</option>
              <option value="seat_selection">Plassvalg</option>
              <option value="seat_deselection">Plass valgt bort</option>
              <option value="order_confirmation">Bestillingsbekreftelse</option>
              <option value="order_check">Status sjekk</option>
              <option value="order_confirmation_email">Bekreftelse epost</option>
              <option value="internal_notification_email">Internt varsel epost</option>
              <option value="server_startup">Server oppstart</option>
              <option value="dev_code_used">Dev kode bruk</option>
            </select>

            <input
              type="text"
              placeholder="Søk etter epost, kode, eller aktivitet..."
              value={this.state.searchTerm}
              onChange={this.handleSearchChange}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ddd",
                minWidth: "300px",
                fontSize: "14px"
              }}
            />

            <select
              value={this.state.itemsPerPage}
              onChange={(e) => this.setState({ itemsPerPage: parseInt(e.target.value, 10), currentPage: 1 })}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ddd",
                fontSize: "14px"
              }}
            >
              <option value="25">25 per side</option>
              <option value="50">50 per side</option>
              <option value="100">100 per side</option>
            </select>
          </div>

          <div style={{
            backgroundColor: "#1a1d29",
            color: "white",
            padding: "10px",
            borderRadius: "4px",
            marginBottom: "20px",
            border: "1px solid #495057"
          }}>
            <p style={{ margin: "5px 0", color: "white" }}>
              <strong>Totalt:</strong> {this.state.logs.length} |
              <strong> Filtrert:</strong> {filteredLogs.length} |
              <strong> Auto-oppdatering:</strong> Hvert 30. sekund
              {this.state.refreshing && (
                <span
                  className="refresh-spinner spinning"
                  style={{ marginLeft: "8px" }}
                  title="Refreshing..."
                />
              )}
            </p>
          </div>

          {this.renderPagination(filteredLogs.length, currentPage, itemsPerPage)}

          {this.state.loading ? (
            <LoadAnim />
          ) : (
            <FadeIn>
              <div className="logs-container">
                {Object.keys(groupedLogs).length === 0 ? (
                  <p>Ingen aktivitetslogger funnet som matcher dine kriterier.</p>
                ) : (
                  Object.keys(groupedLogs).map(dateKey => (
                    <div key={dateKey} style={{ marginBottom: "30px" }}>
                      <h3 style={{
                        backgroundColor: "#2B3E50",
                        color: "white",
                        padding: "10px 15px",
                        margin: "0 0 15px 0",
                        borderRadius: "6px",
                        fontSize: "16px",
                        border: "1px solid #495057"
                      }}>
                        <span role="img" aria-label="calendar">📅</span> {new Date(dateKey).toLocaleDateString('nb-NO', {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </h3>

                      <div style={{ marginBottom: "20px" }}>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th style={{ width: "40px" }}>Type</th>
                              <th style={{ width: "140px" }}>Dato & Tid</th>
                              <th>Aktivitet</th>
                              <th style={{ width: "200px" }}>Epost</th>
                              <th style={{ width: "80px" }}>Kode</th>
                              <th>Detaljer</th>
                            </tr>
                          </thead>
                          <tbody>
                            {groupedLogs[dateKey].map((log, index) => {
                              const formattedLog = this.formatLogEntry(log);
                              const logColor = this.getLogColor(log.type);
                              const logIconData = this.getLogIcon(log.type);

                              return (
                                <tr key={index}>
                                  <td style={{
                                    textAlign: "center",
                                    fontSize: "22px",
                                    verticalAlign: "middle"
                                  }}>
                                    <span
                                      title={logIconData.tooltip}
                                      style={{ cursor: "help" }}
                                    >
                                      {logIconData.icon}
                                    </span>
                                  </td>
                                  <td style={{
                                    fontSize: "14px",
                                    fontFamily: "monospace"
                                  }}>
                                    <div>{new Date(log.timestamp).toLocaleDateString('nb-NO')}</div>
                                    <div style={{ color: "#adb5bd" }}>
                                      {new Date(log.timestamp).toLocaleTimeString('nb-NO')}
                                    </div>
                                  </td>
                                  <td style={{
                                    fontWeight: "500",
                                    color: logColor,
                                    fontSize: "14px",
                                    verticalAlign: "middle"
                                  }}>
                                    {formattedLog.title}
                                  </td>
                                  <td style={{
                                    fontSize: "14px",
                                    fontFamily: "monospace",
                                    verticalAlign: "middle"
                                  }}>
                                    {log.email || "-"}
                                  </td>
                                  <td style={{
                                    fontSize: "14px",
                                    fontFamily: "monospace",
                                    backgroundColor: this.getCodeColor(log.code),
                                    padding: log.code ? "4px 6px" : "8px",
                                    borderRadius: log.code ? "3px" : "0",
                                    verticalAlign: "middle",
                                    textAlign: "center"
                                  }}>
                                    {log.code || "-"}
                                  </td>
                                  <td style={{
                                    fontSize: "14px"
                                  }}>
                                    {formattedLog.details}
                                    {log.ipAddress && (
                                      <div style={{
                                        fontSize: "12px",
                                        color: "#adb5bd",
                                        marginTop: "2px"
                                      }}>
                                        IP: {log.ipAddress}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </FadeIn>
          )}

          {this.renderPagination(filteredLogs.length, currentPage, itemsPerPage)}
        </div>
      );
    }
  }
);


// WEBPACK FOOTER //
// ./src/Components/Admin/ActivityLogs.js